import type { paths } from '../types/api/generated';
import { ffhClient } from '@lib/api/ffh-client';

// The response is an inline type in the spec rather than a named schema.
export type PublishedLineupsResponse =
  paths['/predicted-lineups/gameweeks/{gameweek}']['get']['responses'][200]['content']['application/json'];
export type PublishedLineup = PublishedLineupsResponse['data'][number];
export type PublishedLineupPlayer = PublishedLineup['players'][number];
export type TacticalLine = NonNullable<
  PublishedLineupPlayer['tacticalRole']
>['line'];
export type TacticalLane = NonNullable<
  PublishedLineupPlayer['tacticalRole']
>['lane'];

/**
 * Public read (FFH-2916): the eleven the content team entered in ffh-admin for
 * every club with a published lineup in the gameweek. No token, so it can run
 * inside getStaticProps.
 */
export const fetchPublishedLineups = async (
  gameweek: number
): Promise<PublishedLineup[]> => {
  const { data, error } = await ffhClient().GET(
    '/predicted-lineups/gameweeks/{gameweek}',
    { params: { path: { gameweek } } }
  );

  if (error) throw new Error('Failed to load predicted lineups');
  return data?.data ?? [];
};
